import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Alert from '@mui/material/Alert'
import CloseIcon from '@mui/icons-material/Close'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { deleteUser } from './Functions'
import { invalidateQuery, FC } from '../../Services'

export const DeleteDialog = ({ open, onClose, user }) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    if (!user?._id) return
    setIsDeleting(true)

    const success = await deleteUser(user._id, FC.service('users'))

    setIsDeleting(false)
    if (success) {
      invalidateQuery('users')
      onClose()
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      aria-labelledby='delete-dialog-title'
    >
      <DialogTitle
        id='delete-dialog-title'
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <WarningAmberIcon color='warning' />
          <Typography variant='h6' component='span' fontWeight={600}>
            Elimina Utente
          </Typography>
        </Box>
        <IconButton onClick={onClose} size='small' aria-label='Chiudi'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2 }}>
        <Alert severity='warning' variant='outlined' sx={{ mb: 2 }}>
          Questa azione è irreversibile.
        </Alert>
        <Typography variant='body1'>
          Sei sicuro di voler eliminare l'utente{' '}
          <strong>{user?.name} {user?.lastName}</strong>
          {' '}({user?.email})?
        </Typography>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button
          onClick={onClose}
          variant='outlined'
          size='small'
          sx={{ textTransform: 'none', fontWeight: 500 }}
        >
          Annulla
        </Button>
        <Button
          onClick={handleDelete}
          variant='contained'
          color='error'
          size='small'
          disabled={isDeleting}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {isDeleting ? 'Eliminazione...' : 'Elimina'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
